"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var handleDropdownVisibleChange = function handleDropdownVisibleChange(props) {
  var open = props.open,
    autoBlurOnSelected = props.autoBlurOnSelected,
    onDropdownVisibleChange = props.onDropdownVisibleChange;
  if (autoBlurOnSelected === true && open === false) {
    document.activeElement.blur();
  }
  if (typeof onDropdownVisibleChange === 'function') {
    onDropdownVisibleChange(open);
  }
};
var _default = exports["default"] = handleDropdownVisibleChange;